import request from '@/utils/request'
import Cookies from 'js-cookie'
import config from '../config/config'
import { Message } from 'element-ui'
import { getTime } from '@/utils/index'
import { isWeixin, wechatAuthorize } from '@/api/public';
const TRS_URL = config.TRS_URL;
const NEW_TRS_URL = config.NEW_TRS_URL;
const BIZ_URL = config.BIZ_URL;


const user = getUserData() || {}
const userId = user['_id'];
if (process.env.NODE_ENV === 'development') {
  Cookies.set('cy_user',JSON.stringify({
    "_id": "5b17a8ad3c15d6000caefd57", 
    "name": "wang90", 
    "last_acted_at": 1541138240.592882, 
    "avatar": "http://qzapp.qlogo.cn/qzapp/1105852039/7710F701172A33645624B3D948592077/100",
  }))
  // Cookies.set('cy_user', JSON.stringify({
  //   '_id': '5a326996adae20000c64d505',
  //   'name': 'wang90',
  //   'last_acted_at': 1532400111.99656,
  //   "is_login": true,
  //   'avatar': 'http://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaELmj2vIf4looKLsYx5iaaGDMoyrgXjBL5vbAEcym2oScc3ExVrxVhM8DEElpfibmE0669WbmL8Ejicgw/132'}
  // ))
  // Cookies.set('cy_user', JSON.stringify({
  //   _id: '5a0968ee830f7876a48aac45',
  //   name: '罗三水', last_acted_at: 1526984090.075394,
  //   avatar: 'http://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83epLUtzZpAGGK6HSAOvQ4ibPnHZOJVN7bOIAh4dPguCAkIOlcaF99x793aXk5eI5LhOQTdPUP9Ku5rA/132' }
  // ))
}
const userInfo = {
  point: 0,
  isVip: false,
  vipExpire: '',
  username: '',
  _id: '',
  avatar: 'https://caiyunapp.com/imgs/webtrs/default.png',
  mvp: 0,
  translation: 0,
  liked: 0,
}

function weixinLogin(){
  if(isWeixin() && userId){
    wechatAuthorize();
  }
}

export function USER_INFO(obj) {
  obj = obj? obj : {};
  const vipExpire = obj['vipExpire'];
  userInfo['point'] = obj['point'] ||  userInfo['point'];
  userInfo['isVip'] = obj['isVip'] || userInfo['isVip'];
  userInfo['vipExpire'] = vipExpire ? getTime(Math.floor(obj['vipExpire'])) : userInfo['vipExpire'];
  userInfo['username'] = obj['username'] || userInfo['username'];
  userInfo['_id'] = obj['_id'] || userInfo['_id'];
  userInfo['avatar'] = obj['avatar'] || userInfo['avatar'];
  userInfo['mvp'] = obj['mvp'] || userInfo['mvp'];
  userInfo['liked'] = obj['liked'] || userInfo['liked'];
  userInfo['translation'] = obj['translation'] ||  userInfo['translation'];
  return userInfo;
}

export function getUserData() {
  try {
    let u = Cookies.get('cy_user') || '{}';
    if (!u || u === '') {
      console.error('user not found')
      weixinLogin()
      return {}
    }
    const user = JSON.parse(u) || {};
    return user
  } catch (err) {
    weixinLogin()
    Message({
      message: '您已经登出，请重新登录...',
      type: 'warning',
      duration: 5 * 1000,
    })
  }
}

export function getTranslateSentence(params) {
  return request({
    url: `${TRS_URL}/v1/user/${userId}/sentence?page_size=10&page=${params.page}`,
    method: 'post',
    data: {
      user_id: userId,
    },
  })
}

export function getHistory(params) {
  params['user_id'] = userId
  return request({
    url: `${TRS_URL}/v1/user/${userId}/page?page_size=10&page=${params.page}`,
    method: 'post',
    data: params,
  })
}

export function getDocRecord(params) {
  return request({
    url: `${TRS_URL}/v1/doc/${userId}/translate?page_size=10&page=${params.page}`,
    method: 'post',
    data: {
      user_id: userId,
    } })
}

export function getFavorite(params) {
  params['user_id'] = userId;
  return request({
    url: `${TRS_URL}/v1/user/${userId}/article?page_size=${params.page_size}&page=${params.page}`,
    method: 'post',
    data: params,
  })
}

export function getArticle(params) {
  params['user_id'] = userId;
  return request({
    url: `${TRS_URL}/v1/user/${userId}/article/${params.article_id}`,
    method: 'post',
    data: params,
  })
}
export function getArticlePublic(params) {
  params['user_id'] = userId;
  return request({
    url: `${TRS_URL}/v1/user/${userId}/article/${params.article_id}/public`,
    method: 'post',
    data: params,
  })
}

// api-staging.interpreter.caiyunai.com/v1/user/
export function logout() {
  // console.log("logout:0", Cookies.get("cy_user"))
  Cookies.remove('cy_user', { path: '' })
  Cookies.remove('cy_user', { path: '/', domain: '.caiyunapp.com' })
  // console.log("logout:1", Cookies.get("cy_user"))
  return request({
    url: `${BIZ_URL}/v1/web/logout`,
    method: 'post',
    data: {
      user_id: userId
    },
  })
}
export function payDoc(docId) {
  return request({
    url: `${NEW_TRS_URL}/v1/doc/${docId}/pay`,
    method: 'post',
    data: {
      'user_id': userId,
      'os_type': 'web',
      'version': '1.0.3',
      'pay_channel': 'alipay'
    },
  })
}
export function payDocSync(docId) {
  return request({
    url: `${NEW_TRS_URL}/doc/${docId}/pay/sync`,
    method: 'get',
  })
}

export function rechargeVIP(proId) {
  return request({
    url: `${TRS_URL}/v1/user/redeem`,
    method: 'post',
    data: {
      "user_id": userId,
      "product_id": +proId,
      "os_type": "web",
      "version": "1.0.3",
      "timestamp": 0,
      "pay_channel":"alipay"
    },
  })
}

export function getVipList() {
  return request({
    url: `${TRS_URL}/v1/product`,
    method: 'post',
    data: {
      'user_id': userId,
      'os_type': 'web'
    },
  })
}

export function upUserInfo() {
  return request({
    url: `${TRS_URL}/v1/user/${userId}`,
    method: 'post',
    data: {
      'user_id': userId
    },
  })
}


export function upUserData() {
  upUserInfo().then( res => {
    if( res.rc === 0 && res.user) {
      return  USER_INFO({
        point: res.user.point || 0,
        isVip: res.user.biz.is_xy_vip || false,
        vipExpire: res.user.biz.xy_vip_expire,
        username: res.user.username || '',
        _id: res.user._id || '',
        avatar: res.user.avatar_url || '',
        mvp: res.user.mvp_count || '',
        liked: res.user.be_liked_count || '',
        translation: res.user.translation_count || '',
      });xw
    }
  })
}


export function changeUserInfo(id, name) {
  return request({
    url: `${BIZ_URL}/v1/user/${id}/name`,
    method: 'post',
    data: {
      'name': name,
    },
  })
}

export function getUserPoint(id, page) {
  return request({
    url: `${TRS_URL}/v1/user/point?page_size=20&page=${page}`,
    method: 'post',
    data: {
      'user_id': id,
    },
  })
}

export function delDocItem(id) {
  return request({
    url: `${TRS_URL}/v1/doc/${id}/delete`,
    method: 'get',
  })
}

export function isPayDone(id) {
  return request({
    url: 'https://ad.caiyunapp.com/pay/check',
    method: 'post',
    data: {
      'id': id,
    },
  })
}


// WEBPACK FOOTER //
// ./src/api/user.js